import { type BudgetMixDatumSummaryData } from "@north-beam/nb-common";
import { useSelectedCycle } from "@pages/mmm/hooks/use-selected-cycle";

type Props = {
  formatCurrencyApproximate: (value: number) => string;
  summaryData: BudgetMixDatumSummaryData;
};

export const SpendCard = ({
  formatCurrencyApproximate,
  summaryData,
}: Props) => {
  const { totalDaysInCycle } = useSelectedCycle();

  return (
    <div className="flex items-center justify-between bg-cosmic-4 h-16 rounded-lg p-3 basis-1/3">
      <div className="font-semibold leading-4">Spend</div>
      <div className="flex items-center gap-1">
        <div className="text-xs font-semibold">Total</div>
        <div className="text-lg text-cosmic">
          {formatCurrencyApproximate(summaryData.spend)}
        </div>
        <div className="h-5 border-l"></div>
        <div className="text-xs font-semibold">Avg. Daily</div>
        <div className="text-lg text-cosmic">
          {formatCurrencyApproximate(summaryData.spend / totalDaysInCycle)}
        </div>
      </div>
    </div>
  );
};
